export class User {
  _id!: string;
  id: number;
  email!: string;
  password!: string;
  operatorCode: number;
  name!: string;
  lastname?: string;
  businessName!: string;
  cuitName!: string;
  address!: string;
  enabled?: boolean;
  role!: any;
  token!: string;
  isCharger?: boolean;
  phoneNumber!: string;
  tanks!: number[];
  deleted: boolean;
  tankId: number;
}

